var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTypeWav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 27 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M18.8545 6.56533C18.1165 6.56463 17.4089 6.27474 16.887 5.75929C16.3652 5.24385 16.0717 4.54495 16.071 3.816V2.47762e-07H3.63402C3.15686 -0.00017489 2.68433 0.0925024 2.24344 0.272738C1.80255 0.452973 1.40194 0.717238 1.06447 1.05043C0.727005 1.38363 0.459303 1.77922 0.27666 2.21462C0.0940173 2.65003 -3.29465e-08 3.11671 0 3.588V25.2173C0.00143099 26.1682 0.384973 27.0797 1.06637 27.7515C1.74776 28.4232 2.67128 28.8004 3.63402 28.8H18.5643C19.0413 28.8 19.5137 28.7072 19.9544 28.5269C20.3952 28.3466 20.7956 28.0823 21.133 27.7491C21.4703 27.4159 21.7379 27.0204 21.9204 26.5851C22.103 26.1498 22.1969 25.6832 22.1969 25.212V6.56533H18.8545Z",
    fill: "#00C650"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.197 6.56533H18.8546C18.1166 6.56463 17.409 6.27474 16.8871 5.75929C16.3653 5.24385 16.0718 4.54495 16.071 3.816V0L22.197 6.56533Z",
    fill: "#00C650"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.832 22.7466H7.95241C6.75506 22.7466 5.78442 23.7053 5.78442 24.8879V29.8586C5.78442 31.0412 6.75506 31.9999 7.95241 31.9999H24.832C26.0293 31.9999 27 31.0412 27 29.8586V24.8879C27 23.7053 26.0293 22.7466 24.832 22.7466Z",
    fill: "#00C650"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.63174 28.4492V29.4186H8.61523V28.4492H9.63174Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6606 25.4092L14.69 29.4185H13.4751L12.8271 26.7358L12.1724 29.4185H10.9574L9.98682 25.4092H11.0546L11.577 28.3132L12.2898 25.4092H13.3698L14.0825 28.3132L14.6103 25.4092H15.6606Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6926 28.6868H17.1699L16.9175 29.4188H15.8848L17.3697 25.4375H18.5009L19.9859 29.4188H18.941L18.6926 28.6868ZM18.4388 27.9495L17.934 26.4762L17.4237 27.9495H18.4388Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1264 25.4092L22.12 28.4265L23.1135 25.4092H24.1638L22.7517 29.4185H21.4828L20.0762 25.4092H21.1264Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2301 17.5893H14.7452V11.688C14.7452 11.4903 14.6657 11.3007 14.5242 11.1609C14.3827 11.0212 14.1908 10.9426 13.9906 10.9426H10.2108C10.0107 10.9426 9.81873 11.0212 9.67721 11.1609C9.53569 11.3007 9.4562 11.4903 9.4562 11.688V17.5893H7.97803V11.1893C7.97803 10.736 8.16036 10.3012 8.48491 9.98063C8.80946 9.66007 9.24965 9.47998 9.70863 9.47998H14.4887C14.9477 9.47998 15.3879 9.66007 15.7125 9.98063C16.037 10.3012 16.2194 10.736 16.2194 11.1893L16.2301 17.5893Z",
    fill: "#00C650"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.478 19.3202C15.4458 19.3202 16.2302 18.5454 16.2302 17.5896C16.2302 16.6337 15.4458 15.8589 14.478 15.8589C13.5103 15.8589 12.7258 16.6337 12.7258 17.5896C12.7258 18.5454 13.5103 19.3202 14.478 19.3202Z",
    fill: "#00C650"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.72023 19.3202C8.68795 19.3202 9.47244 18.5454 9.47244 17.5896C9.47244 16.6337 8.68795 15.8589 7.72023 15.8589C6.75251 15.8589 5.96802 16.6337 5.96802 17.5896C5.96802 18.5454 6.75251 19.3202 7.72023 19.3202Z",
    fill: "#00C650"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeWav);
export default __webpack_public_path__ + "static/media/Type=WAV.39f0eb4115e6a00ad6fd69e149f013e0.svg";
export { ForwardRef as ReactComponent };